import React, { useState, useEffect } from "react";
import { Spinner, Table, Badge } from "react-bootstrap";
import { DatatableWrapper, TableBody, TableHeader, Pagination } from "react-bs-datatable";
import solisPowerApi from "../../api/solisPowerApi";
import { ROUTES } from "../../constants/webRouting";
import { Link } from "react-router-dom";
import { formatDateForView } from "../../utils/helper";

const RelatedListQuotation = ({ lead }) => {
  const [body, setBody] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchQuotations = async () => {
    try {
      setLoading(true);
      const result = await solisPowerApi.fetchQuotationsByLeadId(lead.id);
      if (result && Array.isArray(result)) {
        setBody(result);
      } else {
        setBody([]);
      }
    } catch (error) {
      console.error("Error fetching related quotations:", error);
      setBody([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (lead?.id) {
      fetchQuotations();
    }
  }, [lead?.id]);

  const formatCurrency = (amount) => {
    return "Rs. " + Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const header = [
    {
      title: "Quotation No",
      prop: "estimate_number",
      cell: (row) => (
        <Link 
          to={`${ROUTES.QUOTATION.VIEW.replace(":id", row.id)}`} 
          state={row}
          className="text-decoration-none fw-bold"
          style={{ color: "#364794" }}
        >
          {row.estimate_number || "-"}
        </Link>
      ),
    },
    { title: "Project Name", prop: "project_name" },
    {
      title: "Total Amount",
      prop: "payable_amount",
      cell: (row) => formatCurrency((row.payable_amount !== undefined && row.payable_amount !== null) ? row.payable_amount : row.total_amount),
    },
    {
      title: "Status",
      prop: "status",
      cell: (row) => (
        <Badge
          bg={
            row.status === "Approved"
              ? "success"
              : row.status === "Draft"
              ? "secondary"
              : "info"
          }
        >
          {row.status || "Draft"}
        </Badge>
      ),
    },
    {
      title: "Created Date",
      prop: "createddate",
      cell: (row) => (row.createddate ? formatDateForView(row.createddate) : "-"),
    },
  ];

  return (
    <div className="related-quotations-section">
      {loading ? (
        <div className="text-center py-4">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : body.length > 0 ? (
        <DatatableWrapper
          body={body}
          headers={header}
          paginationOptionsProps={{
            initialState: {
              rowsPerPage: 5,
            },
          }}
        >
          <Table striped bordered hover responsive className="shadow-sm rounded">
            <TableHeader classes={{ th: "bg-custom text-white" }} />
            <TableBody />
          </Table>
          <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
        </DatatableWrapper>
      ) : (
        <div className="text-center py-4 text-muted border rounded bg-light">
          No quotations found for this lead
        </div>
      )}
    </div>
  );
};

export default RelatedListQuotation;
